import { i18n } from "../../../i18n";
import { CountryLanguageResponse, CountryOption } from "../../../../types";

export type LocaleSelection = {
  country: string;
  language: string;
};

export const labelClass = "tw:block tw:font-bold tw:text-base tw:mb-3";

/**
 * Translate into the language chosen in the picker rather than the page language, so only the modal changes.
 * Falls back to the page language if that language's messages haven't loaded.
 */
export function translate(
  key: string,
  language: string,
  params: string | string[] = []
) {
  const translation = i18n(key, params, language);
  return translation === key ? i18n(key, params) : translation;
}

export function findCountry(
  data: CountryLanguageResponse,
  country: string
): CountryOption | undefined {
  return data.countries.find((option) => option.country === country);
}

export function formatCurrency(country?: CountryOption) {
  if (!country?.currency) return "";

  return country.currencySymbol && country.currencySymbol !== country.currency
    ? `${country.currencySymbol} ${country.currency}`
    : country.currency;
}

export function flagHref(country: string) {
  const spritesheet =
    window?.resourceUrls?.flagSpriteSheet ??
    "/marketplace/images/sprite-flag.svg";
  return `${spritesheet}#${country}`;
}
